import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  WFacebookCommentDefinition,
  WFacebookCommentPlatformProps,
  WFacebookCommentCarmiProps,
} from '../WFacebookComment.types';
import { getSocialCompBlockingLayerProps } from '../../../preview-utils/socialComponents';
import { props as viewerPropsMapper } from './WFacebookComment.mapper';

const props = composeMapper<
  PreviewWrapperProps<WFacebookCommentPlatformProps>,
  WFacebookCommentDefinition,
  WFacebookCommentCarmiProps
>()(
  viewerPropsMapper,
  { add: ['componentViewMode', 'isSocialInteractionAllowed'] },
  (resolver, deps, carmiData) => {
    const viewerProps = viewerPropsMapper.resolver(deps, carmiData);
    return {
      ...viewerProps,
      previewWrapperProps: {
        componentViewMode: deps.componentViewMode,
        ...getSocialCompBlockingLayerProps(deps.isSocialInteractionAllowed),
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
